export default "__VITE_ASSET__CcmGGSfq__"